import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { showIntlConfirmDialog } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";

class CustomErrorBoundry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }
    }

    checkUploadError = (errMsg) => {
        if (errMsg.includes("Invalid time value")) {
            this.props.uploadSaveUploadedData({});
            this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastuploaddata", {});
            this.props.setCustomUploadInfo({ "SavedDataError": errMsg });
        } else
            this.props.setCustomUploadInfo({ "ComponentError": errMsg });

        showIntlConfirmDialog("somethingWrongMsg", this.props.intl.formatMessage);
        this.props.setupCustomForm({ formState: 'closed' });
        this.props.uploadSetState();
        this.props.closed();
    }

    checkSearchError = (errMsg) => {
        if (errMsg.includes("Invalid time value")) {
            this.props.expertSearchSaveData({});
            this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastsearchdata", {});
            this.props.setCustomSearchInfo({ "SavedDataError": errMsg });
        } else
            this.props.setCustomSearchInfo({ "ComponentError": errMsg });

        showIntlConfirmDialog("somethingWrongMsg", this.props.intl.formatMessage);
        this.props.searchClosed();
    }
    componentDidCatch(error, info) {
        if (error && error.toString()) {
            let errMsg = error.toString();
            if (this.props.formName === CustomTypes.UPLOAD_FORM || this.props.formName === CustomTypes.UPLOAD_INTO_MASTER) {
                this.checkUploadError(errMsg);
            } else if (this.props.formName === CustomTypes.SEARCH_FORM) {
                this.checkSearchError(errMsg);
            }
        }

        this.setState({ hasError: true })
    }

    render() {
        if (this.state.hasError) {
            return (<div></div>)
        }
        return this.props.children;
    }
}


const mapStateToProps = state => {
    return {
        lg: state.ui.language,
        user: state.auth.user,
        uploadState: state.uploadFiles.uploadState,
        searchedObj: state.ui.searchedObj,
        addFormState: state.customData.addFormState,
        newData: state.customData.newData,
        customCurrentDialog: state.customData.customCurrentDialog,
        customUploadInfo: state.customData.customUploadInfo,
        customSearchInfo: state.customData.customSearchInfo
    };
};
const mapDispatchToProps = dispatch => {
    return {
        uploadSetState: () => dispatch(actions.uploadSetState()),
        opened: () => dispatch(actions.uploadOpened()),
        closed: () => dispatch(actions.uploadClosed()),
        searchClosed: () => dispatch(actions.expertSearchClosed()),
        setAddFormState: (formState) => dispatch(actions.setAddFormState(formState)),
        uploadSaveUploadedData: uploadedObj => dispatch(actions.uploadSaveUploadedData(uploadedObj)),
        setupCustomForm: (formState) => dispatch(actions.uploadFormState(formState)),
        updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata4Upload(type, id, metadata)),
        expertSearchSaveData: (obj) => dispatch(actions.expertSearchSaveData(obj)),
        expertSearchSetupData: (obj) => dispatch(actions.expertSearchSetupData(obj)),
        saveNewProject: (newProjectTitle, isPrivate) => dispatch(actions.saveNewProjectForUpload(newProjectTitle, isPrivate)),
        saveLastCustomData: (userdata, option, lastCustomData) => dispatch(actions.saveLastCustomData4User(userdata, option, lastCustomData)),
        setCurrentDialog: (data) => dispatch(actions.setCustomCurrentDialog(data)),
        setCustomUploadInfo: (info) => dispatch(actions.setCustomUploadInfo(info)),
        setCustomSearchInfo: (info) => dispatch(actions.setCustomSearchInfo(info))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CustomErrorBoundry)));
